/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.querySelectorAll(".glb_mute").forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentDiv = btn.parentElement; // find nearest parent div
      const currentVideo = parentDiv.querySelector("video");
      if (currentVideo && !currentVideo.paused) {
        document.querySelectorAll(".off_sound_global, .video_selector").forEach((wrapper) => {
          const video = wrapper.querySelector("video");
          const playBtn = wrapper.querySelector('.glb_play');
          const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
          if (video !== currentVideo && !video.paused) {
            video.muted = true;
            //video.pause();
            const parentDivELe = video.parentElement;
            const muteBtn = parentDivELe.querySelector(".glb_mute");
            if (muteBtn) {
              muteBtn.classList.add("muted");
            }
          }
        });
      }
    });
  });
  function offsoundAllVideos(currentWrapper = null) {
    const isMobile = window.innerWidth <= 767;
    const allOtherVideos = document.querySelectorAll('.off_sound_global');

    allOtherVideos.forEach((wrapper) => {
      // Skip the current (active) video
      if (currentWrapper && wrapper === currentWrapper) return;

      const video = wrapper.querySelector("video");
      const playBtn = wrapper.querySelector('.glb_play');
      const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      const muteBtn = wrapper.querySelector(".glb_mute");

      if (!video) return;

      // Pause and mute all other videos
      video.pause();
      video.muted = true;

      // Reset UI states
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
      if (muteBtn) muteBtn.classList.add('muted');
    });
  }



  function initCustomVideoPlayerWithHLS(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

            


      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = false;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              playBtn?.classList.add('playing');
              
            })
            .catch(() => {
              playBtn?.classList.remove('playing');
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo( otherVideo = null, vWrapper = null ) {
        if( otherVideo )
        {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        }
        else{
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if( autoplay && video )
        {
          if (muteBtn.classList.contains('muted')) {
            video.muted = true;
            if (muteBtn) {
              muteBtn.classList.add('muted');
            }
          }
          else{
            video.muted = false;
          }
          
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.video_selector');
          if (!wrap) return;
          //&& !isOutOfView(wrap)
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          offsoundAllVideos(wrapper);
          safePlay();
          video.muted = false;
          if (muteBtn) {
            muteBtn.classList.remove('muted');
          }
        } else {
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

  document.querySelectorAll(".init_hls_video").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomVideoPlayerWithHLS(sectionID);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".init_hls_video");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomVideoPlayerWithHLS(sectionID);
    }
  });




  function safePlayUsingFlickity( section, videoWrapper )
  {
    //offsoundAllVideos(videoWrapper);
    const playBtn = videoWrapper.querySelector('.glb_play');
    const video = videoWrapper.querySelector('video');
    const videoPoster = videoWrapper.querySelector(".custom-poster-wrapper");

    const carousel = section.querySelector('.customer-love-it__slider');
    const flkty = window.theme.Flickity.data(carousel);
    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(() => {
        playBtn?.classList.add('playing');
        video.onended = () => {
          video.pause();
          playBtn?.classList.remove('playing');
          if (videoPoster) videoPoster.style.opacity = 1;
          if (flkty) flkty.next();
        };
      })
      .catch(() => {
        playBtn?.classList.remove('playing');
        if (videoPoster) videoPoster.style.opacity = 1;
      });
    }
  }
  function initCustomerLoverItHlsVideo(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.customer_love_it_video');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    // ✅ Progress bar helper
    function attachVideoProgress(video, wrapper) {
      let progressBar = wrapper.querySelector('.video-progress-bar');
      if (!progressBar) {
        progressBar = document.createElement('div');
        progressBar.className = 'video-progress-bar';
        Object.assign(progressBar.style, {
          position: 'absolute',
          bottom: '10px',
          left: '10px',
          width: 'calc(100% - 20px)',
          height: '4px',
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: '2px',
          overflow: 'hidden',
          zIndex: 3,
        });

        const progressFill = document.createElement('div');
        progressFill.className = 'video-progress-fill';
        Object.assign(progressFill.style, {
          width: '0%',
          height: '100%',
          background: '#fff',
          transition: 'width 0.2s linear',
        });

        progressBar.appendChild(progressFill);
        wrapper.appendChild(progressBar);
      }

      const progressFill = progressBar.querySelector('.video-progress-fill');
      let rafId = null;

      function updateProgress() {
        if (!video.paused && !video.ended && video.duration > 0) {
          const percent = (video.currentTime / video.duration) * 100;
          progressFill.style.width = `${percent}%`;
          rafId = requestAnimationFrame(updateProgress);
        }
      }

      video.addEventListener('play', () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(updateProgress);
      });

      video.addEventListener('pause', () => {
        cancelAnimationFrame(rafId);
      });

      video.addEventListener('ended', () => {
        cancelAnimationFrame(rafId);
        progressFill.style.width = '0%';
      });

      video.addEventListener('loadedmetadata', () => {
        progressFill.style.width = '0%';
      });
    }

    // Loop through all videos
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

      const shouldAutoplay = () => (wrapper.closest('div.carousel-cell.is-selected'));

      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster setup
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      var mtp = true;
      video.removeAttribute('muted');
      if (shouldAutoplay()) {
        var mtp = true;
        video.setAttribute('muted', '');
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      video.muted = mtp;

      function safePlay( clicked = false) {
        const carousel = section.querySelector('.customer-love-it__slider');
        const flkty = window.theme.Flickity.data(carousel);
        if (!flkty) return;
        const parentCell = video.closest('.carousel-cell');
        if (parentCell && !parentCell.classList.contains('is-selected')) {
          const cellIndex = flkty.cells.findIndex(cell => cell.element === parentCell);
          if (cellIndex >= 0) flkty.select(cellIndex);
        }

        setTimeout(() => {
          console.log("clicked",clicked);
          if( clicked ){  
            if (muteBtn) muteBtn.classList.remove('muted');
            video.muted = false;
          }
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                playBtn?.classList.add('playing');
                video.onended = () => {
                  video.pause();
                  playBtn?.classList.remove('playing');
                  if (posterWrapper) posterWrapper.style.opacity = 1;
                  if (flkty) flkty.next();
                };
              })
              .catch(() => {
                playBtn?.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
          }
        }, 0);
      }

      video.addEventListener('playing', () => {
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });

      function pauseVideo(otherVideo = null, vWrapper = null) {
        if (otherVideo) {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        } else {
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        

        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }
        if (autoplay && video) {
          video.muted = true;
          if (muteBtn) muteBtn.classList.add('muted');
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';

        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              attachVideoProgress(video, wrapper); // ✅ attach progress bar
              if (autoplay) safePlay();
            }, { once: true });
          } else {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({
                  maxBufferLength: 3,
                  startLevel: -1,
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  attachVideoProgress(video, wrapper); // ✅ attach progress bar
                  if (autoplay) safePlay();
                });
              }
            });
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            attachVideoProgress(video, wrapper); // ✅ attach progress bar
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
      }

      // Observer logic
      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.customer_love_it_video');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);

          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          offsoundAllVideos(wrapper);
          safePlay(true);
          video.muted = false;
          if (muteBtn) muteBtn.classList.remove('muted');
        } else {
          if (muteBtn) muteBtn.classList.add('muted');
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

  function initCustomerLoverItSlider(section) {
    
    const slider = section.querySelector(".customer-love-it__slider");
    const desktop  = parseInt(slider.dataset.slidesDesktop) || 3;
    const tablet   = parseInt(slider.dataset.slidesTablet)  || 2;
    const mobile   = parseInt(slider.dataset.slidesMobile)  || 1;
    const autoPlay = false;
    const nav   = slider.dataset.showNav == "true";
    const totalSlides = slider.querySelectorAll(".carousel-cell").length;

    function alignment(){
      if (window.innerWidth > 1024) return 'center';
      if (window.innerWidth >= 768)  return 'center';
      return 'left';
    }
    function getGroupCells(){
      if (window.innerWidth > 1024) return desktop;
      if (window.innerWidth >= 768)  return tablet;
      return mobile;
    }
    function getOptions() {
      const slidesToShow = getGroupCells();
      const contain_v = totalSlides <= slidesToShow;
      const wrap_v    = totalSlides > slidesToShow;
      var truenav = false
      if( nav && wrap_v ){
        truenav = true; 
      }
      return {
        cellAlign: alignment(),
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: autoPlay > 0 ? autoPlay : false,
        prevNextButtons: truenav,
        pageDots: false,
        draggable: wrap_v,
        touchVerticalScroll: false,
        adaptiveHeight: false,
      };
    }

    // init Flickity
    let flkty = new window.theme.Flickity(slider, getOptions());

    // reinit on resize if breakpoint changes
    let lastSlidesToShow = getGroupCells();
    let lastAlign = alignment();


    window.addEventListener("resize", () => {
      const newSlidesToShow = getGroupCells();
      const newAlign = alignment();

      if (newSlidesToShow !== lastSlidesToShow || newAlign !== lastAlign) {
        flkty.destroy();
        flkty = new window.theme.Flickity(slider, getOptions());
        lastSlidesToShow = newSlidesToShow;
        lastAlign = newAlign;
      } else {
        flkty.resize();
      }
    });

    // flkty.on('settle', () => {
    //   const currentCell = flkty.selectedElement;
    //   const video_wrapper = currentCell?.querySelector('.customer_love_it_video');
    //   if (video_wrapper) {
    //     safePlayUsingFlickity(section, video_wrapper);
    //   }
    // });
    // Fires immediately when slide changes
    flkty.on('change', (index) => {
      const allVideos = section.querySelectorAll('.customer_love_it_video');

      // Pause all videos immediately
      allVideos.forEach((videoWrapper) => {
        const video = videoWrapper.querySelector('video');
        if (video && !video.paused) {
          video.pause();
          video.currentTime = 0; // optional: reset to start
        }
      });

      // Play video in the new slide after change
      const currentCell = flkty.cells[index].element;
      const currentVideoWrapper = currentCell.querySelector('.customer_love_it_video');
      const playBtn = currentCell.querySelector('.glb_play');

      if (currentVideoWrapper) {
        //playBtn.click();
        //safePlayUsingFlickity(section, currentVideoWrapper);
      }
    });

  }
  document.querySelectorAll(".customer-love-it").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomerLoverItHlsVideo(sectionID);
    initCustomerLoverItSlider(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".customer-love-it");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomerLoverItHlsVideo(sectionID);
      initCustomerLoverItSlider(section);
    }
  });
  
  // 🔧 Customizer events
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target;
    if (section.classList.contains("customer-love-it")) {
      initCustomerLoveIt(section);
    }
  });


  function initModalVideoPlayerWithHLS(sectionId) {
    
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video) return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';
      const muteBtn = wrapper.querySelector('.glb_mute');
      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;
      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = false;
      muteBtn.classList.remove('muted');

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              if (posterWrapper) posterWrapper.style.opacity = 0;
              
            })
            .catch(() => {
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }
      const progressBar = section.querySelector('#videoModal .progress-bar');

      video.addEventListener('timeupdate', () => {
        if (video.duration) {
          const progressPercent = (video.currentTime / video.duration) * 100;
          progressBar.style.width = progressPercent + "%";
        }
      });
      
      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        if (autoplay)
        { 
          safePlay();
          video.onended = () => {
            const activeItem = section.querySelector('.product_in_use_slider_item.active');
            if (!activeItem) return;
            const currentThumb = activeItem.querySelector('.video-thumb');
            if (!currentThumb) return;
            const thumbs = [...section.querySelectorAll('.video-thumb')];
            const currentIndex = thumbs.indexOf(currentThumb);

            // pick next (or loop to first)
            let nextThumb = thumbs[currentIndex + 1] || thumbs[0];
            console.log("nextThumb",nextThumb)
            // update active class
            section.querySelectorAll('.product_in_use_slider_item.active').forEach(item => item.classList.remove('active'));
            nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');
            // trigger click on next thumb
            nextThumb.click();
          }
        }
      }
      loadVideo();
      

      if (muteBtn && !muteBtn.dataset.listenerAttached) {
        muteBtn.style.display = 'block';
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
        muteBtn.dataset.listenerAttached = "true";
      }

      
    });
  }
  function initProductInUseSlider(section){
    const slider = section.querySelector(".product_in_use_slider");
    if( !slider ) return;
    const desktop = parseInt(slider.dataset.desktop) || 5;
    const tablet  = parseInt(slider.dataset.tablet)  || 3;
    const mobile  = parseInt(slider.dataset.mobile)  || 2;
    const autoPlay = parseInt(slider.dataset.autoplay) || 3000;
    const wrap = slider.dataset.wrap === "true";

    function getGroupCells() {
        if (window.innerWidth >= 1024) return desktop;
        if (window.innerWidth >= 768) return tablet;
        return mobile;
    }
    const totalSlides = slider.querySelectorAll(".product_in_use_slider_item").length;
    
    let flkty = null;
    
    function initFlickityIfNeeded() {
        const slidesToShow = getGroupCells();
        const shouldInitFlickity = totalSlides > slidesToShow;
        
        // If Flickity is already initialized but shouldn't be, destroy it
        if (flkty && !shouldInitFlickity) {
            flkty.destroy();
            flkty = null;
            slider.classList.remove('flickity-enabled');
            return;
        }
        
        // If Flickity shouldn't be initialized and isn't, do nothing
        if (!shouldInitFlickity && !flkty) {
            return;
        }
        
        // If Flickity should be initialized but isn't, initialize it
        if (shouldInitFlickity && !flkty) {
            flkty = new window.theme.Flickity(slider, {
                cellAlign: "left",
                contain: false,
                imagesLoaded: true,
                wrapAround: true,
                autoPlay: false,
                prevNextButtons: true,
                pageDots: false,
                draggable: true,   
                touchVerticalScroll: false,
            });
        } else if (flkty && shouldInitFlickity) {
            // If already initialized and should be, just resize
            flkty.resize();
        }
    }
    
    // Initialize on load
    initFlickityIfNeeded();
    
    // Handle resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            initFlickityIfNeeded();
        }, 250);
    });
    // open modal on thumbnail click
    section.querySelectorAll('.video-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.videoSrc;
        const poster = thumb.dataset.poster;

        const modal = section.querySelector('#videoModal');
        const video = modal.querySelector('video');
        // set dataset so init function can pick it up
        video.dataset.desktopVideo = src;
        video.dataset.mobileVideo = src;
        video.dataset.desktopPoster = poster;
        video.dataset.mobilePoster = poster;
        modal.classList.add('open');

        const title = thumb.dataset.title;
        modal.querySelector(".title_and_btns h2").innerHTML = title;
        const progressBar = modal.querySelector('.progress-bar');
        progressBar.style.width =  "0%";
        const parentItem = thumb.closest('.product_in_use_slider_item');
        if (parentItem) {
          section.querySelectorAll('.product_in_use_slider_item').forEach(el => el.classList.remove('active')); 
          parentItem.classList.add('active');
        }
        // init your player inside modal
        initModalVideoPlayerWithHLS(section.getAttribute('data-section-id'));
      });
    });

    function showNext() {
        const activeItem = section.querySelector('.product_in_use_slider_item.active');
        if (!activeItem) return;

        const currentThumb = activeItem.querySelector('.video-thumb');
        if (!currentThumb) return;

        const thumbs = [...section.querySelectorAll('.video-thumb')];
        const currentIndex = thumbs.indexOf(currentThumb);

        // pick next (or loop to first)
        const nextThumb = thumbs[currentIndex + 1] || thumbs[0];

        // update active class
        section.querySelectorAll('.product_in_use_slider_item.active')
              .forEach(item => item.classList.remove('active'));
        nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');

        // trigger click on next thumb
        nextThumb.click();
      }
      
      function showPrev() {
        const activeItem = section.querySelector('.product_in_use_slider_item.active');
        if (!activeItem) return;

        const currentThumb = activeItem.querySelector('.video-thumb');
        if (!currentThumb) return;

        const thumbs = [...section.querySelectorAll('.video-thumb')];
        const currentIndex = thumbs.indexOf(currentThumb);

        // pick prev (or loop to last)
        const prevThumb = thumbs[currentIndex - 1] || thumbs[thumbs.length - 1];

        // update active class
        section.querySelectorAll('.product_in_use_slider_item.active')
              .forEach(item => item.classList.remove('active'));
        prevThumb.closest('.product_in_use_slider_item')?.classList.add('active');

        // trigger click on prev thumb
        prevThumb.click();
      }
      section.querySelector('.glb_next').addEventListener('click', () => showNext());
      section.querySelector('.glb_prev').addEventListener('click', () => showPrev());

    // close modal
    section.querySelectorAll('#videoModal .modal-close, #videoModal .modal-overlay').forEach(el => {
      el.addEventListener('click', () => {
        const modal = section.querySelector('#videoModal');
        const video = modal?.querySelector('video');
        if (video) {
          video.pause();
          if (video.hlsInstance) {
            video.hlsInstance.destroy();
            video.hlsInstance = null;
          }
        }
        modal?.classList.remove('open');
      });
    });

    

  }
  document.querySelectorAll("product-info").forEach(section => {
    initProductInUseSlider(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector("product-info");
    if (section) {
      initProductInUseSlider(section);
    }
  });

  

  function handleCartUpdate() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartIds = cart.items.map(item => item.product_id);
        const related = document.querySelector('.cart-related-products__list--slider');
        const cartRelated = document.querySelector('.cart-related-products');
        if (!related) return;

        const sliderEl = related;
        const flkty = window.theme?.Flickity?.data(sliderEl);
        if (!flkty) return;

        // Create hidden pool if not exist
        let hiddenPool = related.querySelector('.hidden-cells');
        if (!hiddenPool) {
          hiddenPool = document.createElement('div');
          hiddenPool.classList.add('hidden-cells');
          hiddenPool.style.display = 'none';
          related.appendChild(hiddenPool);
        }

        const allCells = [
          ...flkty.cells.map(c => c.element),
          ...hiddenPool.querySelectorAll('[data-product-id]')
        ];

        let visibleCount = 0;

        allCells.forEach(cellElem => {
          const pId = parseInt(cellElem.getAttribute('data-product-id'), 10);
          const inCart = cartIds.includes(pId);
          const isInFlickity = flkty.getCellElements().includes(cellElem);

          if (inCart && isInFlickity) {
            // Move to hidden pool
            flkty.remove(cellElem);
            hiddenPool.appendChild(cellElem);
          } else if (!inCart && !isInFlickity) {
            // Restore from hidden pool
            sliderEl.appendChild(cellElem);
            flkty.append(cellElem);
            visibleCount++;
          } else if (!inCart) {
            visibleCount++;
          }
        });

        // Refresh Flickity
        

        // Hide entire section if no visible slides
        cartRelated.style.display = visibleCount === 0 ? 'none' : '';
        flkty.reloadCells();
        flkty.resize();
      });
  }

  // Listen to both events
  document.addEventListener('theme:cart:update', handleCartUpdate);
  document.addEventListener('theme:cart:change', handleCartUpdate);






  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
